import i18n from 'constants/translation/i18n';

const dataManagementWorkflow = () => {
  const entries = [
    {
      area: 'category_management',
      title: i18n.t('CATEGORY_MANAGEMENT'),
      href: '/dataManagement/category'
    },
    {
      area: 'product_management',
      title: i18n.t('PRODUCT_MANAGEMENT'),
      href: '/dataManagement/product'
    }
    // {
    //   area: 'solution_type',
    //   title: i18n.t('SOLUTION_TYPE'),
    //   href: '/dataManagement/solutionType'
    // },
    // {
    //   area: 'task_type',
    //   title: i18n.t('TASK_TYPE'),
    //   href: '/dataManagement/taskType'
    // }
  ];
  return entries;
};

export default dataManagementWorkflow;
